import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-solution-pilars',
  templateUrl: './solution-pilars.component.html',
  styleUrls: ['./solution-pilars.component.scss']
})
export class SolutionPilarsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
